import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { ApplicationAccessControlFullFindInterface } from '@zaoblako/shared/modules/security/dtos/application/access-control/application-access-control-full-find.dto';
import type { RoomAccessFindInterface } from '@zaoblako/shared/modules/security/dtos/room-access/room-access-find.dto';
import type { RoomAccessFormInterface } from '@zaoblako/shared/modules/security/dtos/room-access/room-access-form.dto';
import type { UserDeleteQueryInterface } from '@zaoblako/shared/modules/security/dtos/user/user-delete-query.dto';
import type { UserEmailInterface } from '@zaoblako/shared/modules/security/dtos/user/user-email.dto';
import type { UserRegistryQueryInterface } from '@zaoblako/shared/modules/security/dtos/user/user-registry-query.dto';import type { UserRegistryPageInterface } from '@zaoblako/shared/modules/security/dtos/user/user-registry-page.dto';
import type { UserNeedDelegateInterface } from '@zaoblako/shared/modules/security/dtos/user/user-need-delegate.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService {
  protected baseUrl = '/basis/security/user';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findRegistryItems(params?: UserRegistryQueryInterface): Observable<UserRegistryPageInterface> {
    return this.http.get<UserRegistryPageInterface>(`${this.baseUrl}/items`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public restorePassword(body: UserEmailInterface): Observable<null> {
    return this.http.post<null>(`${this.baseUrl}/restore-password`, body);
  }

  public getAccessControlRules(): Observable<ApplicationAccessControlFullFindInterface> {
    return this.http.get<ApplicationAccessControlFullFindInterface>(`${this.baseUrl}/access-control-rules`);
  }

  public ban(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/ban`, null);
  }

  public unban(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/unban`, null);
  }

  public remove(id: number, queryParams?: UserDeleteQueryInterface): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`, { params: this.objectToHttpParams(queryParams) });
  }

  public getPacsAccess(id: number): Observable<RoomAccessFindInterface> {
    return this.http.get<RoomAccessFindInterface>(`${this.baseUrl}/${id}/pacs-access`);
  }

  public setPacsAccess(id: number, body: RoomAccessFormInterface): Observable<RoomAccessFindInterface> {
    return this.http.put<RoomAccessFindInterface>(`${this.baseUrl}/${id}/pacs-access`, body);
  }

  public needDelegate(id: number): Observable<UserNeedDelegateInterface> {
    return this.http.get<UserNeedDelegateInterface>(`${this.baseUrl}/${id}/need-delegate`);
  }
}
